<template>
  <div class="item-bg">
    <a-row type="flex" justify="space-between" >
      <a-col :span="12" >
        <span>{{$t('edit.settings.defaultSet')}}</span>
      </a-col>
      <a-col :span="6">
        <a-checkbox @change="onChange">{{$t('enum.advStatus.1')}}</a-checkbox>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <img class="image" :src="dataObj.src" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name:"TempItem",
  props: {
    dataObj: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onChange(e) {
      console.log(e.target.checked);
    },
  },
};
</script>

<style lang="less" scoped>
.item-bg {
  font-size: 14px;
  .image {
    width: 100%;
    height: 192px;
  }
}
</style>